
export const pages = ['מערכת להושבת עובדים', 'הושבת עובדים'];

export const API_URL = 'https://calculate-yb3bki3jea-uc.a.run.app/';

declare global {
    var placements : object;
    var revenue : String;
    var product_screws: Number;
    var product_handle: Number;
    var product_water: Number;
    var product_piston: Number;
}

